import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=718e95bc&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=718e95bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e95bc",
  null
  
)

export default component.exports